// extracted by mini-css-extract-plugin
module.exports = {"con":"following_con__31RB5","ListItem":"following_ListItem__2TSaL","Header":"following_Header__3GiW_","nameList":"following_nameList__1z0ry","uname":"following_uname__28mYB"};